import { Inject, Optional } from "@angular/core";
import { FormArray } from "@angular/forms";
import { FieldType } from "./field.type";

import { clone, isNullOrUndefined, assignFieldValue } from "../utils";
import { KreFormBuilder } from "../services/kre-form.builder";
import { KreFormFieldConfig } from "../components/kre-form.field.config";
import { KreFORM_CONFIG, KreFormExtension } from "../services/kre-form.config";
import {
  registerControl,
  unregisterControl,
  findControl,
} from "../extensions/field-form/utils";
import { Directive } from "@angular/core";

@Directive({ selector: "[ɵfieldArray]" })
export abstract class FieldArrayType<
    F extends KreFormFieldConfig = KreFormFieldConfig
  >
  extends FieldType<F>
  implements KreFormExtension
{
  get formControl() {
    return this.field.formControl as FormArray;
  }

  defaultOptions: any = {
    defaultValue: [],
  };

  get isRemove() {
    let result = true;
    if (this.editor == false) {
      result = false;
    }
    return result;
  }

  get isAdd() {
    let result = true;
    if (
      this.editor == false ||
      (!!this.operationProperty &&
        this.operationProperty.canAdd !== undefined &&
        this.operationProperty.canAdd === false)
    ) {
      result = false;
    } else if (
      this.to.maxLength &&
      this.to.maxLength > 0 &&
      this.field.fieldGroup.length >= this.to.maxLength
    ) {
      result = false;
    }
    return result;
  }
  get isDelete() {
    let result = true;
    if (
      this.editor == false ||
      (!!this.operationProperty &&
        this.operationProperty.canDelete !== undefined &&
        this.operationProperty.canDelete === false)
    ) {
      result = false;
    }
    return result;
  }

  constructor(@Inject(KreFORM_CONFIG) @Optional() builder?: KreFormBuilder) {
    super();
  }

  onPopulate(field: KreFormFieldConfig) {
    if (!field.formControl && field.key) {
      const control = findControl(field);
      registerControl(
        field,
        control
          ? control
          : new FormArray([], { updateOn: field.modelOptions.updateOn })
      );
    }

    field.fieldGroup = field.fieldGroup || [];

    const length = field.model ? field.model.length : 0;
    if (field.fieldGroup.length > length) {
      for (let i = field.fieldGroup.length - 1; i >= length; --i) {
        unregisterControl(field.fieldGroup[i]);
        field.fieldGroup.splice(i, 1);
      }
    }

    for (let i = field.fieldGroup.length; i < length; i++) {
      const f = { ...clone(field.fieldArray), key: `${i}` };
      field.fieldGroup.push(f);
    }
  }

  add(initialModel?: any, { markAsDirty } = { markAsDirty: true }) {
    let i = this.field.fieldGroup ? this.field.fieldGroup.length : 1;
    if (
      this.to.maxLength &&
      this.to.maxLength > 0 &&
      this.field.fieldGroup.length >= this.to.maxLength
    ) {
      (<any>this.options)._buildForm(true);
    } else {
      if (!this.model) {
        assignFieldValue(this.field, []);
      }
      this.model.splice(i, 0, {});
      (<any>this.options)._buildForm(true);
      markAsDirty && this.formControl.markAsDirty();
    }
  }

  remove(i: number, { markAsDirty } = { markAsDirty: true }) {
    i = isNullOrUndefined(i) ? this.field.fieldGroup.length : i;

    if (
      this.to.minLength != undefined &&
      this.to.minLength != null &&
      this.to.minLength > 0 &&
      this.field.fieldGroup != undefined &&
      this.to.minLength >= this.field.fieldGroup.length
    ) {
    } else {
      if (this.field.fieldGroup.length > 0) {
        this.model.splice(i, 1);
        console.log(this.model);

        unregisterControl(this.field.fieldGroup[i], true);
        this.field.fieldGroup.splice(i, 1);
        this.field.fieldGroup.forEach((f, key) => (f.key = `${key}`));

        (<any>this.options)._buildForm(true);
        markAsDirty && this.formControl.markAsDirty();
      }
    }
  }
}
